import { render } from "./Products.vue?vue&type=template&id=670d8ff6&scoped=true&ts=true"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"

import "./Products.vue?vue&type=style&index=0&id=670d8ff6&lang=scss&scoped=true"
import "./Products.vue?vue&type=style&index=1&id=670d8ff6&scoped=true&lang=scss"
import "./Products.vue?vue&type=style&index=2&id=670d8ff6&scoped=true&lang=scss"
import "./Products.vue?vue&type=style&index=3&id=670d8ff6&scoped=true&lang=scss"

import exportComponent from "/home/travis/build/indochat/official-website/www.ecomm-cloud.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670d8ff6"]])

export default __exports__